import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import seo_45global from "/opt/buildhome/repo/middleware/seo.global.js";
import video_45player_45global from "/opt/buildhome/repo/middleware/video-player.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  seo_45global,
  video_45player_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/buildhome/repo/middleware/auth.js"),
  clustersie: () => import("/opt/buildhome/repo/middleware/clustersie.js"),
  "request-middleware": () => import("/opt/buildhome/repo/middleware/requestMiddleware.js")
}